<mat-card class="subscriptions-body">
    <div class="settings-heading">eClose ROI Settings</div>
    <p class="section-title">
        Set the amount that you estimate you're saving versus traditional closing method for each
        eClose option. Default figures are based on SimpleNexus research.
    </p>
    <br />
    <div style="padding-bottom: 20px">
        <kendo-grid #grid="kendoGrid" class="lg-kendo-grid" [data]="gridData">
            <kendo-grid-column
                [style]="{ width: '15%' }"
                [headerStyle]="{ width: '15%' }"
                field="eCloseOption"
                title="Closing Method"
            >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    {{ dataItem.eCloseOption }}
                    <span style="color: red" *ngIf="dataItem.error">
                        <p class="error-message">Maximum value is $1000.</p>
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column
                field="roi"
                title="Estimated Savings"
                [style]="{ width: '10%' }"
                [headerStyle]="{ width: '10%' }"
            >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <span
                        style="padding-right: 10px; color: red"
                        class="error-message-icon"
                        *ngIf="dataItem.error"
                        ><i class="fas fa-exclamation-circle ng-star-inserted form-error"></i
                    ></span>
                    <mat-form-field appearance="outline" style="width: 100px; height: 55px">
                        <mat-label>Savings</mat-label>
                        <input
                            matInput
                            [ngModel]="dataItem.roi | currency: 'USD':true"
                            (ngModelChange)="dataItem.roi = updateInput($event, dataItem)"
                            [ngClass]="{ 'form-error': dataItem.error }"
                            type="text"
                            [ngModelOptions]="{ updateOn: 'blur' }"
                        />
                    </mat-form-field>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="eCloseDescription" title="Description" [sortable]="false">
            </kendo-grid-column>
        </kendo-grid>
        <button
            (click)="saveOptions()"
            mat-button
            class="eclose-save-button"
            [disabled]="hasErrors"
        >
            Save
        </button>
    </div>
</mat-card>
